import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import { useTranslation } from "react-i18next";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ProyectCardV2 from "../UI/ProyectCardV2";

export const Proyectos = () => {
	const [t] = useTranslation("global");

	const columnsFromBackend = {
		[uuid()]: {
			items: [
				{
					id: uuid(),
					title: "Social Academy",
					content: `SAEstudent`,
					image:
						"https://res.cloudinary.com/devsing/image/upload/v1654288813/Portfolio/Untitled_qx3ael.png",
					link: "https://social-academy-1c439.firebaseapp.com/",
					github: "https://github.com/DEVsign-S-A/social-academy-ui",
					moreBig: false
				},
				{
					id: uuid(),
					title: "Social Academy Enterprise",
					content: `SAEnterprise`,
					image:
						"https://res.cloudinary.com/devsing/image/upload/v1654288797/Portfolio/Web_capture_30-5-2022_143453_social-academy-enterprise.netlify.app_znjgpr.jpg",
					link: "https://social-academy-enterprise.netlify.app/Login",
					github: "https://github.com/DEVsign-S-A/social-academy-enterprise-ui",
					moreBig: false

				},
				{
					id: uuid(),
					title: "Heros App",
					content: `HerosApp`,
					image:
						"https://res.cloudinary.com/devsing/image/upload/v1660520003/Portfolio/Web_capture_7-8-2022_15218_ephemeral-daifuku-759a40.netlify.app_un42nw.jpg",
					link: "https://ephemeral-daifuku-759a40.netlify.app/login",
					github: "https://github.com/kevinShogun/HerosApp",
					moreBig: false
				},
			],
		},
		[uuid()]: {
			items: [
				{
					id: uuid(),

					title: "Calendar app",
					content: "calendarApp",
					image:
						"https://res.cloudinary.com/devsing/image/upload/v1673725320/Screenshot_2023-01-14_131108_qbrwae.png",
					link: "https://calendar-app-kevin.netlify.app/login",
					github: 'https://github.com/kevinShogun/calendar-app-fronted',
					moreBig: true
				},
				{
					id: uuid(),
					title: "Notes app",
					content: "NotesApp",
					image:
						"https://res.cloudinary.com/devsing/image/upload/v1654288796/Portfolio/Web_capture_30-5-2022_143144_vigilant-lamport-eb0a1d.netlify.app_hpm3tz.jpg",
					link: "https://notes-app-kevin.netlify.app/auth/login",
					github: "https://github.com/kevinShogun/Journal_app",
					moreBig: true
				},
				{
					id: uuid(),

					title: "ToDo app",
					content: "ToDoApp",
					image:
						"https://res.cloudinary.com/devsing/image/upload/v1660520003/Portfolio/Web_capture_7-8-2022_165216_localhost_fllhau.jpg",
					link: "https://todo-list-kevin.netlify.app/",
					github: "https://github.com/kevinShogun/Frontend",
					moreBig: true
				},
				{
					id: uuid(),

					title: "Sinnoh's Pokédex app",
					content: "PokedexApp",
					image:
						"https://res.cloudinary.com/devsing/image/upload/v1673725684/Screenshot_2023-01-14_134853_pdko1m.png",
					link: "https://pokemon-stactic-generated-app.vercel.app/",
					github: "https://github.com/kevinShogun/next_stactic_generated_app",
					moreBig: true
				},
			],
		},
	};

	// const data = [];
	const [columns, setColumns] = useState(columnsFromBackend);

	// const sendData = () => {
	//   console.log("columns", columns);
	//   console.log("columnsFromBackend", columnsFromBackend);
	// };

	const onDragEnd = (result, columns, setColumns) => {
		if (!result.destination) return;
		const { source, destination } = result;

		if (columns[destination.droppableId].items.length > 3) {
			return;
		}

		if (source.droppableId !== destination.droppableId) {
			const sourceColumn = columns[source.droppableId];
			const destColumn = columns[destination.droppableId];
			const sourceItems = [...sourceColumn.items];
			const destItems = [...destColumn.items];
			const [removed] = sourceItems.splice(source.index, 1);
			destItems.splice(destination.index, 0, removed);
			setColumns({
				...columns,
				[source.droppableId]: {
					...sourceColumn,
					items: sourceItems,
				},
				[destination.droppableId]: {
					...destColumn,
					items: destItems,
				},
			});
		} else {
			const column = columns[source.droppableId];
			const copiedItems = [...column.items];
			const [removed] = copiedItems.splice(source.index, 1);
			copiedItems.splice(destination.index, 0, removed);
			setColumns({
				...columns,
				[source.droppableId]: {
					...column,
					items: copiedItems,
				},
			});
		}
	};
	return (
		<div>
			<div className="select-none bg-gray-50">
			<br/>
				<h2 className="text-center text-gray-800 font-Montserrat font-bold text-2xl">
					{t("misProyectos")}
				</h2>
				<DragDropContext
					onDragEnd={(result) => onDragEnd(result, columns, setColumns)}
				>
					{Object.entries(columns).map(([id, column], index) => {
						return (
							<div key={index}>
								<br />
								<br />
								<Droppable droppableId={id} key={id} direction="horizontal">
									{(provided, snapshot) => {
										return (
											<div
												{...provided.droppableProps}
												ref={provided.innerRef}
												className={`flex flex-col tabletbig:flex-row ring-1 ring-gray-300 bg-gray-50 rounded-lg mx-7 p-4 ${
													snapshot.isDraggingOver && "shadow-xl ring-gray-400"
												}`}
											>
												{column.items.map((item, index) => {
													return (
														<Draggable
															key={item.id}
															draggableId={item.id}
															index={index}
														>
															{(provided, snapshot) => {
																return (
																	<div
																		ref={provided.innerRef}
																		{...provided.draggableProps}
																		{...provided.dragHandleProps}
																		// className={}`}
																	>
																		<ProyectCardV2 item={item} index={index}/>
																	</div>
																);
															}}
														</Draggable>
													);
												})}
												{provided.placeholder}
											</div>
										);
									}}
								</Droppable>
							</div>
						);
					})}
				</DragDropContext>
			</div>
			<br />
			<br />
			<br />
		</div>
	);
};
